import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { ApplicationLinkCode } from 'src/app/common/services/application-link-codes';
import { ApplicationLinkService } from 'src/app/common/services/application-link.service';
import { FinancialDocumentStatusChangeToBookedModel } from '@saliente/common-documents';

@Component({
    selector: 'expert-book-document-with-zero',
    templateUrl: 'book-document-with-zero.component.html',
    standalone: false
})
export class ExpertBookDocumentWithZeroComponent implements OnInit {
	@Input() public model: FinancialDocumentStatusChangeToBookedModel;

	@Output() public save = new EventEmitter();
	@Output() public close = new EventEmitter();

	constructor(private applicationLinkService: ApplicationLinkService) { }

	public ngOnInit() { }

	public onBookWithZeroHelp() {
		this.applicationLinkService.open(ApplicationLinkCode.ExpertDocumenteActiuni);
	}

	public validateComment(value: string) {
		if (value && (value.length < 20)) {
			return "Comentariul trebuie să aibă minim 20 de caractere!";
		}

		return true;
	}
}
